import { useEffect, useState } from 'react';

// Subscribe to a CSS media query and re-render when it flips. Used for layout
// decisions that Tailwind classes can't express (e.g. a different "show N then
// collapse" count on phones vs. desktop). SSR-safe: defaults to `false` until
// mounted.
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && 'matchMedia' in window
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
